<template>
  <PageTabs
    :tabConfig="tabConfig"
  >
    <router-view />
  </PageTabs>
</template>

<script>
import { UiEvents } from '@jumpcloud/ui-events-vue';
import { eventLocations } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import FeatureTrialMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';
import MspState from 'client/components/models/MspState';
import PageTabs from 'client/components/PageLayouts/PageTabs.vue';

const { accountPage } = eventLocations;

export default {
  name: 'TabbedAccountPage',

  components: {
    PageTabs,
  },

  EventHelper,

  mixins: [
    FeatureTrialMixin,
  ],

  computed: {
    ...mapGetters('FeatureFlagsModule', ['betaFeatures']),

    ...mapGetters('SubscriptionCollection', {
      activeSubscriptions: 'getCollection',
    }),

    tabConfig() {
      const tabs = [
        {
          name: 'Overview',
          label: 'Overview',
        },
        {
          name: 'Invoices',
          label: 'Invoices',
        },
        {
          name: 'Payment Info',
          label: 'Payment Info',
        },
        {
          name: 'Upgrade',
          label: 'Upgrade',
          visible: !!this.betaFeatures.upgradePage
            && this.getIsCustomer
            && !MspState.isAnMsp,
        },
      ];

      return tabs
        .filter(({ visible }) => visible === undefined || visible)
        .map(({ name, label }) => ({ name, label }));
    },
  },

  beforeRouteUpdate(to, _, next) {
    this.handleTabSelected(to.meta.title);
    next();
  },

  created() {
    this.fetchAddOns()
      .catch(() => notify('error', 'Unable to fetch add-on list'));
    this.fetchPlan()
      .then(() => (this.activeSubscriptions.length ? null : this.fetchSubscriptions()))
      .catch(() => notify('error', 'Unable to fetch plan'));
  },

  methods: {
    ...mapActions('PlanModule', ['fetchPlan']),

    ...mapActions('AddOnCollection', {
      fetchAddOns: 'fetchCollection',
    }),

    handleTabSelected(tabText) {
      UiEvents.triggerTabClicked({
        description: 'navigate account tabs',
        page: accountPage,
        text: tabText,
        section: `${tabText} Tab`,
      });
    },
  },
};
</script>
